<script setup>
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { _GET_DATE_2 } from '@/helper/formatDate';
import Loading from '@/components/common/Loading';

const route = useRoute();
const loading = ref(false);
const data = ref([]);
const statistics = ref([]);
const result = ref([]);
const emotion_cooperation_result_by_day = ref([]);
const student = ref(null);
const chartOptions = ref({
	dataLabels: {
		enabled: false,
	},
	colors: ['#7AD2C6', '#93BF56', '#F8BB54', '#F47C7C', '#E5E7EB'],
	labels: [
		'Đạt 80 - 100%',
		'Đạt 55 - 75%',
		'Đạt 30 - 50%',
		'Đạt 5 - 25%',
		'X',
	],
	legend: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				return value + ' mục tiêu';
			},
		},
	},
	stroke: {
		lineCap: 'round',
	},
});
const chartOptions3 = ref({
	colors: ['#9EDF93', '#D0DB54', '#FFE68C', '#FF9D6D', '#FF6967'],
	chart: {
		width: 380,
		type: 'polarArea',
	},
	labels: ['Vui vẻ', 'Bình thường', 'Khó chịu', 'Tức giận', 'Bùng nổ'],
	fill: {
		opacity: 1,
		colors: ['#9EDF93', '#D0DB54', '#FFE68C', '#FF9D6D', '#FF6967'],
	},
	stroke: {
		lineCap: 'round',
	},
	yaxis: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				if (!value || value == 'null') {
					return 'Không thực hiện';
				}
				return value + '%';
			},
		},
	},
	legend: {
		show: false,
	},
	dataLabels: {
		enabled: false,
	},
	plotOptions: {
		polarArea: {
			rings: {
				strokeWidth: 0,
			},
			spokes: {
				strokeWidth: 0,
			},
		},
	},
});
const mixChartOptions = ref({
	chart: {
		type: 'line',
		stacked: false,
	},
	dataLabels: {
		enabled: true,
		enabledOnSeries: [0, 1],
		offsetY: -10,
		background: {
			enabled: true,
			foreColor: '#334155',
		},
		formatter: function (val) {
			return val + '%';
		},
	},
	stroke: {
		width: [0.5, 0.5, 4],
	},
	yaxis: [
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
	],
	tooltip: {
		fixed: {
			enabled: true,
			position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
			offsetY: 30,
			offsetX: 60,
		},
	},
	legend: {
		horizontalAlign: 'left',
		offsetX: 40,
	},
	plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '20%',
			borderRadius: 4,
		},
	},
	labels: [],
	colors: ['#FFD270', '#DA8F8F', '#6ED0B9'],
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
const emotion_cooperation_result_by_day_data = ref([
	{
		name: 'Cảm xúc',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Sự tham gia',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Kết quả buổi học',
		type: 'line',
		data: [0, 0, 0, 0, 0],
	},
]);
const emotion_cooperation_result_by_day_emotion = ref([]);
const emotion_cooperation_result_by_day_rating = ref([]);
const emotion_cooperation_result_by_day_result = ref([]);
const emotion_cooperation_result_by_day_labels = ref([]);
const mixChart = ref(null);
const radarChartOptions = ref({
	chart: {
		id: 'radarChart',
		type: 'radar',
	},
	title: {
		show: false,
	},
	stroke: {
		width: 0,
	},
	fill: {
		opacity: 0.2,
		colors: ['#65A30D'],
	},
	markers: {
		size: 5,
		hover: {
			size: 10,
		},
		colors: ['#65A30D'],
	},
	dataLabels: {
		enabled: true,
		formatter: function (val) {
			return val + '%';
		},
		style: {
			fontFamily: 'Gilrory',
			fontSize: '20px',
			fontWeight: 'bold',
			colors: ['#344256'],
		},
		background: {
			enabled: false,
		},
	},
	yaxis: {
		show: false,
		logBase: 100,
		tickAmount: 10,
		min: 0,
		max: 100,
		labels: {
			show: false,
		},
	},
	xaxis: {
		categories: [],
		labels: {
			show: true,
			style: {
				fontFamily: 'Gilrory',
				fontSize: '14px',
				fontWeight: 600,
				colors: Array(1000).fill('#344256'),
			},
			formatter: function (val, index) {
				return index?.dataPointIndex + 1;
			},
		},
	},
	tooltip: {
		x: {
			show: true,
			formatter: function (val, object) {
				return `${object?.dataPointIndex + 1}: ${val}`;
			},
			title: {
				formatter: (seriesName) => seriesName,
			},
		},
		y: {
			show: true,
			formatter: function (val) {
				return val + '%';
			},
			title: {
				title: {
					formatter: (seriesName) => seriesName + ':',
				},
			},
		},
	},
});
const series = ref([]);
const series3 = ref([]);
const radarData = ref([]);
const categories = ref([]);
const assessment_results = ref([]);
const resultDetail = ref(null);
const skillsWithAge = ref([]);
const skills = ref([]);
const range = ref(15);
const note = ref('');
const recommend = ref('');
const isViewedByParents = ref(false);
const staffs = ref([]);
onMounted(() => {
	fetchResultDetail();
	fetchPeriodsReport();
});

watch(
	mixChart,
	() => {
		const optimalColumnWidthPercent =
			12 +
			16 /
				(1 +
					30 *
						Math.exp(
							-emotion_cooperation_result_by_day_emotion.value
								?.length / 3
						));

		setTimeout(() => {
			mixChart.value?.updateOptions({
				plotOptions: {
					bar: {
						columnWidth: optimalColumnWidthPercent + '%',
					},
				},
			});
		}, 1000);
	},
	{ immediate: true, deep: true }
);
const formatDate = (dateString, reverse) => {
	const date = new Date(dateString);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	let formattedDate;
	if (reverse) formattedDate = `${day}/${month}/${year}`;
	else formattedDate = `${year}-${month}-${day}`;
	return formattedDate;
};
const getAgeWidth = (ageInMonths) => {
	const basePx = 64;

	if (ageInMonths <= 72) {
		return (ageInMonths / 6) * basePx + 'px';
	} else {
		const first72 = (72 / 6) * basePx;
		const extraMonths = ageInMonths - 72;
		const extraYears = extraMonths / 12;
		return first72 + extraYears * basePx + 'px';
	}
};
function formatValue(value) {
	if (value < 72) {
		return value + 'th';
	} else {
		const years = Math.floor(value / 12);
		return years + 'T';
	}
}
function getAge(data) {
	if (data) {
		data = data.toLowerCase().trim();
		if (data.includes('tuổi') && data.includes('tháng')) {
			const ageMatch = data.match(/(\d+)\s*tuổi\s*(\d*)\s*tháng?/);
			if (ageMatch) {
				const years = parseInt(ageMatch[1], 10);
				const months = parseInt(ageMatch[2] || '0', 10);
				return years * 2 + (months >= 6 ? 1 : 0);
			}
		} else if (data.includes('tuổi')) {
			const match = data.match(/(\d+)\s*tuổi/);
			if (match) {
				const years = parseInt(match[1], 10);
				return years * 2;
			}
		}
	} else return 15;
}
const formattedValues = computed(() => {
	const unique = new Set();
	const result = [];
	for (let i = 1; i <= range.value; i++) {
		const value = i * 6 - 6;
		const formatted = formatValue(value);
		if (!unique.has(formatted)) {
			unique.add(formatted);
			result.push(formatted);
		}
	}
	return result;
});
const parseAgeToMonths = (ageString) => {
	const yearMatch = ageString.match(/(\d+)\s*tuổi/);
	const monthMatch = ageString.match(/(\d+)\s*tháng/);
	const years = yearMatch ? parseInt(yearMatch[1]) : 0;
	const months = monthMatch ? parseInt(monthMatch[1]) : 0;
	return years * 12 + months;
};
const fetchResultDetail = async () => {
	try {
		const response = await fetch(
			process.env.VUE_APP_BASE_URL +
				`v1/assessment_documents/show_by_token?token=${route?.query?.assessment_result_token}`,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			}
		);
		const res = await response.json();
		if (res) {
			resultDetail.value = res.data;
			isViewedByParents.value = res.is_viewed_by_parents;
			staffs.value = res.staffs;
		}
	} catch (e) {
		console.log(e);
	}
};
const fetchPeriodsReport = async () => {
	loading.value = true;
	try {
		emotion_cooperation_result_by_day.value = [];
		emotion_cooperation_result_by_day_emotion.value = [];
		emotion_cooperation_result_by_day_rating.value = [];
		emotion_cooperation_result_by_day_result.value = [];
		emotion_cooperation_result_by_day_labels.value = [];
		emotion_cooperation_result_by_day_data.value = [
			{
				name: 'Kết quả buổi học',
				type: 'line',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Sự tham gia',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Cảm xúc',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
		];
		const response = await fetch(
			process.env.VUE_APP_BASE_URL +
				`v1/period_reports/show_by_token?token=${route?.query?.report_token}`,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			}
		);
		const res = await response.json();
		if (res) {
			data.value = res;
			statistics.value = res.data;
			student.value = res.student_and_assessment_conclusion;
			range.value = getAge(student.value?.student?.age) + 2;
			note.value = res?.note;
			recommend.value = res?.recomended_for_parent;

			if (
				statistics.value?.goal_count === 0 &&
				data.value?.stats?.attendance === 0
			) {
				loading.value = false;
				return;
			}
			emotion_cooperation_result_by_day.value =
				res.stats?.emotion_cooperation_result_by_day;
			assessment_results.value = res.skills;
			skillsWithAge.value = res?.skill_notes_and_ages.filter(
				(i) => i.age
			);
			if (res?.skill_notes_and_ages.length > 0) {
				skills.value = assessment_results.value.map((item) => {
					const match = res?.skill_notes_and_ages.find(
						(i) => i.id === item?.skill?.id
					);
					return { ...item, ...match };
				});
			}
			let a = [];
			let count = 0;
			result.value = res.stats?.result;
			result.value.forEach((item) => {
				if (
					item.result === 'Từ chối' ||
					item.result === 'Không có cơ hội' ||
					item.result === 'Không hợp tác'
				) {
					count += item.count;
				} else {
					a.push(item);
				}
			});
			a.push({
				result: 'X',
				count: count,
			});
			series.value = a.map((item) => {
				return item.count;
			});
			let series3Total = 0;
			res.stats?.emotion_scale.forEach((item) => {
				return (series3Total += item.count);
			});
			series3.value = res.stats?.emotion_scale.map((item) => {
				const r = (item.count * 100) / series3Total;
				return Math.round(r * 10) / 10 || 0;
			});
			emotion_cooperation_result_by_day.value.forEach((item) => {
				emotion_cooperation_result_by_day_emotion.value.push(
					+(+item.emotion_scale / 5) * 100 || null
				);
				emotion_cooperation_result_by_day_rating.value.push(
					+(+item.cooperation_scale / 5) * 100 || null
				);
				emotion_cooperation_result_by_day_result.value.push(
					+item.complete_percent || null
				);
				emotion_cooperation_result_by_day_labels.value.push(
					_GET_DATE_2(item.date, true)
				);
			});
			emotion_cooperation_result_by_day_data.value[1] = {
				name: 'Cảm xúc',
				type: 'column',
				data: emotion_cooperation_result_by_day_emotion.value,
			};
			emotion_cooperation_result_by_day_data.value[0] = {
				name: 'Sự tham gia',
				type: 'column',
				data: emotion_cooperation_result_by_day_rating.value,
			};
			emotion_cooperation_result_by_day_data.value[2] = {
				name: 'Kết quả buổi học',
				type: 'line',
				data: emotion_cooperation_result_by_day_result.value,
			};
			const optimalColumnWidthPercent =
				5 +
				15 /
					(1 +
						30 *
							Math.exp(
								-emotion_cooperation_result_by_day_labels.value
									?.length / 3
							));

			setTimeout(() => {
				mixChart.value?.updateOptions({
					labels: emotion_cooperation_result_by_day_labels.value,
					plotOptions: {
						bar: {
							columnWidth: optimalColumnWidthPercent + '%',
						},
					},
				});
			}, 1000);
			if (data.value.skills.length) {
				radarData.value = [
					{
						name: 'Kết quả',
						data: data.value.skills.map((skill) => {
							return skill?.skill?.skill_percent;
						}),
					},
				];
				radarChartOptions.value.xaxis.categories =
					data.value.skills.map((skill) => {
						return skill?.skill?.name;
					});
				categories.value = data.value.skills.map((skill) => {
					return skill?.skill?.name;
				});
			}
		}
	} catch (e) {
		console.log(e);
	} finally {
		loading.value = false;
	}
};
</script>
<template>
	<div class="p-10">
		<div v-if="loading" class="mt-10 flex items-center justify-center h-28">
			<Loading />
		</div>
		<div v-else>
			<div class="bg-white shadow-sm rounded-2xl overflow-hidden pb-4">
				<div
					class="bg-orange-50 p-4 px-6 flex md:items-center justify-between text-gray-700 md-down:flex-col"
				>
					<div class="font-semibold text-lg">
						Báo cáo
						<span class="text-green-500">{{
							resultDetail?.name
						}}</span>
					</div>
					<div
						v-if="isViewedByParents"
						class="flex items-center justify-end gap-2"
					>
						Phụ huynh xác nhận đã xem
						<svg
							fill="none"
							height="20"
							viewBox="0 0 20 20"
							width="20"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clip-path="url(#clip0_29861_3992)">
								<path
									d="M9.26745 5.21165H2.62886C1.64009 5.21165 0.833008 6.0187 0.833008 7.0075V14.7761C0.833008 15.7648 1.64006 16.5719 2.62886 16.5719H5.05019L5.05033 19.2959C5.05033 19.9013 5.75664 20.2241 6.20055 19.8205L10.0344 16.5517H13.3235C14.3122 16.5517 15.1193 15.7446 15.1193 14.7558L15.1192 11.0834C11.8907 11.0834 9.26752 8.44011 9.26752 5.21158L9.26745 5.21165Z"
									fill="#339588"
								/>
								<path
									d="M15.1393 0.833008C12.7179 0.833008 10.7606 2.79028 10.7606 5.21165C10.7606 7.63302 12.7179 9.5903 15.1393 9.5903C17.5606 9.5903 19.5179 7.63302 19.5179 5.21165C19.5179 2.79028 17.5606 0.833008 15.1393 0.833008ZM17.2781 4.60631L15.0989 6.78554C14.9778 6.90659 14.7963 6.98738 14.6146 6.98738C14.433 6.98738 14.2514 6.90673 14.1303 6.78554L12.98 5.63532C12.7177 5.37296 12.7177 4.92901 12.98 4.66681C13.2424 4.40445 13.6863 4.40445 13.9485 4.66681L14.5943 5.31258L16.2892 3.61766C16.5516 3.3553 16.9955 3.3553 17.2578 3.61766C17.5606 3.90014 17.5606 4.34407 17.2782 4.60631H17.2781Z"
									fill="#339588"
								/>
								<path
									d="M8.78697 5.71165C9.02947 8.81816 11.5111 11.3196 14.6192 11.5638L14.6193 14.7558C14.6193 14.7558 14.6193 14.7558 14.6193 14.7558C14.6193 15.4685 14.0361 16.0517 13.3235 16.0517H10.0344H9.85017L9.70999 16.1712L5.87615 19.44L5.87008 19.4452L5.86417 19.4506C5.75578 19.5491 5.55033 19.4867 5.55033 19.2959L5.55019 16.5719L5.55017 16.0719H5.05019H2.62886C1.91621 16.0719 1.33301 15.4887 1.33301 14.7761V7.0075C1.33301 6.29485 1.91623 5.71165 2.62886 5.71165H8.78697ZM15.4524 7.1391L17.6251 4.96641C18.1223 4.4978 18.1008 3.72652 17.6051 3.25789C17.1468 2.8064 16.3911 2.80865 15.9357 3.2641L14.5943 4.60547L14.3022 4.31336C14.3022 4.31332 14.3021 4.31329 14.3021 4.31325C13.8446 3.85558 13.0841 3.85572 12.6266 4.31315C12.1688 4.7707 12.1689 5.53131 12.6265 5.98887L13.7767 7.13908C13.7767 7.13909 13.7767 7.13909 13.7767 7.1391C13.9873 7.34967 14.2943 7.48738 14.6146 7.48738C14.9351 7.48738 15.2421 7.34942 15.4524 7.1391ZM11.2606 5.21165C11.2606 3.06643 12.9941 1.33301 15.1393 1.33301C17.2845 1.33301 19.0179 3.06642 19.0179 5.21165C19.0179 7.35688 17.2845 9.0903 15.1393 9.0903C12.994 9.0903 11.2606 7.35688 11.2606 5.21165Z"
									stroke="#339588"
								/>
							</g>
							<defs>
								<clipPath id="clip0_29861_3992">
									<rect fill="white" height="20" width="20" />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
				<div class="flex justify-between p-6 pb-1 flex-wrap">
					<div class="flex-col gap-4">
						<div>
							Ngày bắt đầu:
							{{ formatDate(statistics.start_date, true) }}
						</div>
						<div>
							Ngày kết thúc:
							{{ formatDate(statistics.end_date, true) }}
						</div>
					</div>
					<div class="flex-col gap-4">
						<div class="flex items-center flex-wrap gap-2">
							<div>{{ $filters.terminology('teacher') }}</div>
							<div class="flex items-center flex-wrap gap-1">
								<div
									v-for="(staff, index) in staffs"
									:key="staff.id"
								>
									<div>
										<span
											class="font-semibold text-blue-700"
											>{{ staff?.name }}</span
										><span v-if="index < staffs?.length - 1"
											>,</span
										>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="
								resultDetail?.created_by_staff &&
								resultDetail?.sent_at !== null
							"
							class="flex items-center flex-wrap gap-2"
						>
							<div>
								<div class="font-semibold text-blue-700 mr-1">
									{{ resultDetail?.created_by_staff?.name }}
								</div>
								đã gửi tới PH
								{{ formatDateTime(resultDetail?.sent_at) }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="mt-10 bg-white rounded-2xl shadow-sm overflow-hidden relative"
			>
				<div
					class="__data__header p-6 flex items-center justify-between"
				>
					<div class="text-neutral-600 font-semibold">
						{{ resultDetail?.name }}
					</div>
				</div>
				<div class="__data__content text-neutral-800">
					<div class="flex items-center px-6 py-4 bg-neutral-50">
						<div class="w-1/4 text-neutral-500">Ngày thực hiện</div>
						<div>
							{{
								resultDetail?.assessment_date
									? $filters.formatDate(
											resultDetail?.assessment_date
									  )
									: ''
							}}
						</div>
					</div>
					<div class="flex items-center px-6 py-4">
						<div class="w-1/4 text-neutral-500">Tuổi thực</div>
						<div>{{ resultDetail?.age }}</div>
					</div>
					<div class="flex items-center px-6 py-4 bg-neutral-50">
						<div class="w-1/4 text-neutral-500">
							Tuổi phát triển
						</div>
						<div>
							<div
								v-for="(
									item, index
								) in resultDetail?.development_ages"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
					</div>
					<div class="flex items-center px-6 py-4">
						<div class="w-1/4 text-neutral-500">Kết luận</div>
						<div>
							<div
								v-for="(
									item, index
								) in resultDetail?.assessment_conclusions"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
					</div>
					<div class="flex items-center px-6 py-4 bg-neutral-50">
						<div class="w-1/4 text-neutral-500">Đơn thuốc</div>
						<div>
							<div
								v-for="(
									item, index
								) in resultDetail?.prescription"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
					</div>
					<div
						class="flex items-center px-6 py-4"
						v-if="statistics?.start_date"
					>
						<div class="w-1/4 text-neutral-500">Nhận xét</div>
						<div
							v-if="resultDetail?.note"
							style="flex: 1"
							v-html="
								resultDetail?.note.replaceAll('\n', '<br />')
							"
						></div>
					</div>
					<div
						:class="{ 'bg-neutral-50': statistics?.start_date }"
						class="flex items-center px-6 py-4"
					>
						<div class="w-1/4 text-neutral-500">Tải lên</div>
						<div class="flex items-center">
							<div v-if="resultDetail?.created_by_staff">
								<span class="font-semibold text-blue-700">{{
									resultDetail?.created_by_staff?.name
								}}</span>
								<span class="mx-2">-</span>
							</div>
							{{
								resultDetail?.assessment_date
									? $filters.formatDate(
											resultDetail?.assessment_date
									  )
									: ''
							}}
						</div>
					</div>
					<div
						class="flex items-center px-6 py-4"
						:class="{ 'bg-neutral-50': !statistics?.start_date }"
					>
						<div class="w-1/4 text-neutral-500">
							Chỉnh sửa gần nhất
						</div>
						<div class="flex items-center">
							<div v-if="resultDetail?.edited_by_staff">
								<span class="font-semibold text-blue-700">{{
									resultDetail?.created_by_staff?.name
								}}</span>
								<span class="mx-2">-</span>
							</div>
							{{
								resultDetail?.updated_at
									? $filters.formatDateTime(
											resultDetail?.updated_at
									  )
									: ''
							}}
						</div>
					</div>
				</div>
			</div>
			<div class="relative mt-12">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex items-center justify-center">
					<div
						class="px-2.5 py-1 bg-body text-neutral-600 font-semibold"
					>
						Thống kê chung
					</div>
				</div>
			</div>
			<div class="mt-10">
				<div class="p-6 bg-white shadow-sm rounded-2xl">
					<div class="w-full flex items-center justify-between mb-6">
						<div class="font-semibold text-neutral-600">
							Thống kê chung
						</div>
					</div>
					<div class="flex flex-nowrap w-full md-down:flex-col">
						<div
							class="p-6 border rounded-l-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/abc.png"
									style="height: 32px"
									width="32"
								/>
								{{
									Number(statistics?.skill_count || 0) +
									'/' +
									Number(data?.stats?.total_skill_count || 0)
								}}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Lĩnh vực đã học
								</span>
							</div>
						</div>
						<div
							class="p-6 border-t border-b border-neutral-200 w-full md-down:border-l md-down:border-r md-down:border-b-0"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/light.png"
									style="height: 32px"
									width="32"
								/>
								{{
									Number(statistics?.goal_count || 0) +
									'/' +
									Number(data?.stats?.total_goal_count || 0)
								}}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Mục tiêu đã học
								</span>
							</div>
						</div>
						<div
							class="p-6 border-l border-t border-b border-neutral-200 w-full md-down:border-r md-down:border-b-0"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/light.png"
									style="height: 32px"
									width="32"
								/>
								{{ statistics?.completed || 0 }}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Mục tiêu đã hoàn thành
								</span>
							</div>
						</div>
						<div
							class="p-6 border-l border-t border-b border-neutral-200 w-full md-down:border-r md-down:border-b-0"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/light.png"
									style="height: 32px"
									width="32"
								/>
								{{ statistics?.continued || 0 }}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Mục tiêu sẽ tiếp tục
								</span>
							</div>
						</div>
						<div
							class="p-6 border rounded-r-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none"
						>
							<div
								class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
							>
								<img
									alt=""
									class="mr-2"
									height="32"
									src="@/assets/images/icons/light.png"
									style="height: 32px"
									width="32"
								/>
								{{ statistics?.stopped || 0 }}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Mục tiêu sẽ tạm dừng</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-6" v-if="note || recommend">
				<div class="bg-white shadow-sm rounded-2xl">
					<div
						class="w-full flex items-center justify-between p-6"
						:class="{ 'border-bot': note || recommend }"
					>
						<div class="font-semibold text-neutral-600">
							Nhận xét chung về quá trình can thiệp của trẻ
						</div>
					</div>
					<div class="p-6">
						<div class="mb-4" v-if="note">
							<div
								class="text-gray-400 font-semibold mb-1 uppercase text-xs"
							>
								NHẬN XÉT
							</div>

							<div
								class="text-gray-700"
								v-html="note.replaceAll('\n', '<br />')"
							></div>
						</div>
						<div v-if="recommend">
							<div
								class="text-gray-400 font-semibold mb-1 uppercase text-xs"
							>
								Gợi ý cho phụ huynh
							</div>
							<div
								class="text-gray-700"
								v-html="recommend.replaceAll('\n', '<br />')"
							></div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-6" v-if="skillsWithAge.length > 0">
				<div class="bg-white shadow border-sm rounded-lg">
					<div class="border-bot">
						<div
							class="text-neutral-500 font-semibold border-b p-6"
						>
							Biểu đồ mối tương quan tuổi phát triển và tuổi thực
							của trẻ qua các lĩnh vực đã học
						</div>
						<div
							class="font-semibold text-gray-700 whitespace-nowrap px-6 pt-6 mb-2"
						>
							Lĩnh vực
						</div>
						<div
							class="relative px-6 pb-6 flex items-center text-neutral-500 gap-4 overflow-x-auto"
						>
							<div class="h-full pb-9">
								<div
									:style="{
										height:
											45 * skillsWithAge.length + 'px',
									}"
									class="flex flex-col items-start justify-between"
								>
									<div
										v-for="i in skillsWithAge"
										:key="i.id"
										class="font-semibold text-gray-400 whitespace-nowrap"
									>
										{{ i.name }}
									</div>
								</div>
							</div>
							<div class="w-max flex flex-nowrap pt-6 relative">
								<div
									class="absolute l-0 w-full flex flex-col items-start justify-between"
									:style="{
										height:
											45 * skillsWithAge.length + 'px',
									}"
								>
									<div
										v-for="i in skillsWithAge"
										:key="i.id"
										class="flex items-center gap-2 w-full"
									>
										<div
											:style="{
												width: getAgeWidth(
													i.unit === 'tuổi'
														? i.age * 12
														: i.age
												),
											}"
											class="percent"
										></div>
										<div
											class="text-gray-500 font-semibold text-sm"
										>
											{{
												i.unit === 'tuổi'
													? i.age * 12
													: i.age
											}}
										</div>
									</div>
								</div>
								<div
									v-for="i in formattedValues"
									:key="i"
									class="flex-1 w-16"
								>
									<div
										class="border border-t-0 border-b-0 border-l border-neutral-200"
										:class="{
											'border-r-0':
												i !==
												formattedValues.length - 1,
										}"
										:style="{
											height:
												45 * skillsWithAge.length +
												'px',
										}"
									></div>
									<div
										class="text-neutral-500 text-sm mt-8 font-semibold float-left -ml-2"
									>
										{{ i }}
									</div>
								</div>
								<div
									class="absolute text-gray-500 font-semibold whitespace-nowrap"
									:style="{
										left: getAgeWidth(
											parseAgeToMonths(
												student?.student?.age
											)
										),
										'margin-left': '-25px',
										top: '-5px',
									}"
								>
									{{ student?.student?.age }}
								</div>
								<div
									class="absolute student-age"
									:style="{
										left: getAgeWidth(
											parseAgeToMonths(
												student?.student?.age
											)
										),
										height:
											45 * skillsWithAge.length + 'px',
									}"
								></div>
							</div>
							<div
								class="flex items-end font-semibold text-gray-700 whitespace-nowrap"
								:style="{
									height:
										45 * skillsWithAge.length + 81 + 'px',
								}"
							>
								Tuổi phát triển
							</div>
						</div>
						<div class="text-gray-700 flex item-center gap-10 p-6">
							<div class="flex items-center gap-2">
								<div class="r-age w-4 h-4 rounded-lg"></div>
								<div class="text-sm">Tuổi thực</div>
							</div>
							<div class="flex items-center gap-2">
								<div class="d-age w-4 h-4 rounded-lg"></div>
								<div class="text-sm">Tuổi phát triển</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-6 flex items-stretch gap-6 xl-down:flex-col">
				<div
					class="bg-white shadow-sm rounded-2xl overflow-hidden w-1/3 xl-down:w-full"
				>
					<div class="font-semibold text-neutral-500 p-6">
						Biều đồ cảm xúc
					</div>
					<div
						class="border-t border-orange-50 flex justify-center items-center p-6 flex-col"
					>
						<div
							class="relative w-full md-down:w-full flex items-center justify-center"
						>
							<apexchart
								:options="chartOptions3"
								:series="series3"
								height="220"
								type="donut"
							></apexchart>
							<div
								class="text-center absolute top-1/2 left-1/2 transform"
								style="transform: translate(-50%, -50%)"
							>
								<div class="text-neutral-500">Cảm xúc</div>
							</div>
						</div>
						<div class="w-full">
							<div
								v-if="series3[0] > 0"
								class="flex flex-nowrap items-center justify-between w-full"
							>
								<div class="flex flex-nowrap items-center">
									<img
										alt=""
										height="24"
										src="@/assets/images/emoji/happy.png"
										width="24"
									/>
									<div
										class="h-2.5 w-2.5 rounded-full ml-2"
										style="background: #9edf93"
									></div>
									<div
										class="ml-2 text-base text-neutral-500"
									>
										Vui vẻ
									</div>
								</div>
								<div
									class="text-base text-neutral-600 font-bold"
								>
									{{ series3[0] }}
									%
								</div>
							</div>
							<div
								v-if="series3[1] > 0"
								class="flex flex-nowrap items-center justify-between w-full mt-2.5"
							>
								<div class="flex flex-nowrap items-center">
									<img
										alt=""
										height="24"
										src="@/assets/images/emoji/5565d66a50b44df9ae37a955bdfb3757.png"
										width="24"
									/>
									<div
										class="h-2.5 w-2.5 rounded-full ml-2"
										style="background: #d0db54"
									></div>
									<div
										class="ml-2 text-base text-neutral-500"
									>
										Bình thường
									</div>
								</div>
								<div
									class="text-base text-neutral-600 font-bold"
								>
									{{ series3[1] }}
									%
								</div>
							</div>
							<div
								v-if="series3[2] > 0"
								class="flex flex-nowrap items-center justify-between w-full mt-2.5"
							>
								<div class="flex flex-nowrap items-center">
									<img
										alt=""
										height="24"
										src="@/assets/images/emoji/cf1f643bc1244f5e8e37767bc946d607.png"
										width="24"
									/>
									<div
										class="h-2.5 w-2.5 rounded-full ml-2"
										style="background: #ffe68c"
									></div>
									<div
										class="ml-2 text-base text-neutral-500"
									>
										Khó chịu
									</div>
								</div>
								<div
									class="text-base text-neutral-600 font-bold"
								>
									{{ series3[2] }}
									%
								</div>
							</div>
							<div
								v-if="series3[3] > 0"
								class="flex flex-nowrap items-center justify-between w-full mt-2.5"
							>
								<div class="flex flex-nowrap items-center">
									<img
										alt=""
										height="24"
										src="@/assets/images/emoji/5ede936757cd4fbdb6247bad22bf454d.png"
										width="24"
									/>
									<div
										class="h-2.5 w-2.5 rounded-full ml-2"
										style="background: #ff9d6d"
									></div>
									<div
										class="ml-2 text-base text-neutral-500"
									>
										Tức giận
									</div>
								</div>
								<div
									class="text-base text-neutral-600 font-bold"
								>
									{{ series3[3] }}
									%
								</div>
							</div>
							<div
								v-if="series3[4] > 0"
								class="flex flex-nowrap items-center justify-between w-full mt-2.5"
							>
								<div class="flex flex-nowrap items-center">
									<img
										alt=""
										height="24"
										src="@/assets/images/emoji/0b356bb507d64b9489e2fbced131f795.png"
										width="24"
									/>
									<div
										class="h-2.5 w-2.5 rounded-full ml-2"
										style="background: #ff6967"
									></div>
									<div
										class="ml-2 text-base text-neutral-500"
									>
										Bùng nổ
									</div>
								</div>
								<div
									class="text-base text-neutral-600 font-bold"
								>
									{{ series3[4] }}
									%
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="bg-white shadow-sm rounded-2xl overflow-hidden w-1/3 xl-down:w-full xl-down:mt-6"
				>
					<div class="font-semibold text-neutral-500 p-6">
						Biểu đồ kết quả các mục tiêu
					</div>
					<div
						class="flex flex-nowrap p-6 border-t border-orange-50 items-center justify-center flex-col"
					>
						<div class="relative w-fit md-down:w-full">
							<apexchart
								:options="chartOptions"
								:series="series"
								height="220"
								type="donut"
							></apexchart>
							<div
								class="text-center absolute top-1/2 left-1/2 transform"
								style="transform: translate(-50%, -50%)"
							>
								<div
									class="text-4xl font-bold text-neutral-600"
								>
									{{ statistics?.goal_count }}
								</div>
								<div class="text-neutral-500">Mục tiêu</div>
							</div>
						</div>
						<div
							class="flex flex-col w-full justify-center md-down:mt-4"
						>
							<div
								v-if="result[0]?.count > 0"
								class="flex flex-nowrap items-center mb-4 justify-between"
							>
								<div
									class="text-sm font-semibold text-neutral-500 w-14 blue"
								>
									{{ result[0]?.count }}
									M.T
								</div>
								<span
									class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold whitespace-nowrap w-32 shadow-input"
									style="background: #2aa797"
								>
									{{ result[0]?.result }}
								</span>
							</div>
							<div
								v-if="result[1]?.count > 0"
								class="flex flex-nowrap items-center mb-4 justify-between"
							>
								<div
									class="text-sm text-neutral-500 w-14 font-semibold"
								>
									{{ result[1]?.count }}
									M.T
								</div>
								<span
									class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
									style="background: #65a30d"
								>
									{{ result[1]?.result }}
								</span>
							</div>
							<div
								v-if="result[2]?.count > 0"
								class="flex flex-nowrap items-center mb-4 justify-between"
							>
								<div
									class="text-sm font-semibold text-neutral-500 w-14"
								>
									{{ result[2]?.count }}
									M.T
								</div>
								<span
									class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
									style="background: #f59e0b"
								>
									{{ result[2]?.result }}
								</span>
							</div>
							<div
								v-if="result[3]?.count > 0"
								class="flex flex-nowrap items-center mb-4 justify-between"
							>
								<div
									class="text-sm font-semibold text-neutral-500 w-14 blue"
								>
									{{ result[3]?.count }}
									M.T
								</div>
								<span
									class="flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
									style="background: #f87171"
								>
									{{ result[3]?.result }}
								</span>
							</div>
							<div
								v-if="
									result[4]?.count > 0 ||
									result[5]?.count > 0 ||
									result[6]?.count > 0
								"
								class="flex flex-nowrap items-center mb-4 justify-between"
							>
								<div
									class="text-sm font-semibold text-neutral-500 w-14 blue"
								>
									{{
										result[4]?.count +
										result[5]?.count +
										result[6]?.count
									}}
									M.T
								</div>
								<span
									class="flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
									style="background: #9ca3af"
								>
									X
								</span>
							</div>
						</div>
					</div>
				</div>
				<div
					class="bg-white shadow-sm rounded-2xl overflow-hidden w-1/3 xl-down:w-full xl-down:mt-6"
				>
					<div class="font-semibold text-neutral-500 p-6">
						Chuyên cần
					</div>
					<div
						class="border-t border-orange-50 p-6 flex items-center justify-center flex-col"
					>
						<div
							class="text-neutral-600 font-semibold mb-5"
							style="font-size: 72px"
						>
							{{ data?.stats?.attendance }}
						</div>
						<div class="text-neutral-500 mb-5 text-center">
							Số ngày học
						</div>
					</div>
				</div>
			</div>
			<div class="mt-6">
				<div
					class="bg-white shadow-sm rounded-2xl overflow-hidden mb-10 pb-5"
				>
					<div class="font-semibold text-neutral-500 p-6">
						Mối tương quan giữa kết quả, cảm xúc và sự tham gia của
						trẻ từ
						{{ formatDate(statistics?.start_date, true) }} tới
						{{ formatDate(statistics?.end_date, true) }}
					</div>
					<div
						class="p-6 border-t border-orange-50 md-down:px-0 overflow-x-auto w-full"
					>
						<apexchart
							ref="mixChart"
							:options="mixChartOptions"
							:series="emotion_cooperation_result_by_day_data"
							:style="{
								minWidth: `${
									emotion_cooperation_result_by_day_emotion?.length *
									150
								}px`,
							}"
							height="600"
							style="width: 100%"
							width="100%"
						></apexchart>
					</div>
				</div>
			</div>
			<div
				v-if="radarData.length && radarData[0]?.data.length >= 3"
				class="mt-12"
			>
				<div
					class="bg-white shadow-sm overflow-hidden rounded-2xl mb-10 pb-5"
				>
					<div class="font-semibold text-neutral-500 p-6">
						Biểu đồ mối tương quan giữa kết quả các lĩnh vực từ
						{{ formatDate(statistics?.start_date, true) }} tới
						{{ formatDate(statistics?.end_date, true) }}
					</div>
					<div
						class="p-6 border-t border-orange-50 md-down:px-0 overflow-x-auto w-full"
					>
						<apexchart
							:options="radarChartOptions"
							:series="radarData"
							height="700"
							type="radar"
						></apexchart>
						<div
							class="py-4 flex flex-wrap gap-6 justify-center items-center"
						>
							<div
								v-for="(c, index) in categories"
								:key="c"
								class="flex items-center flex-nowrap gap-2"
							>
								<div class="font-bold text-lf text-neutral-700">
									{{ index + 1 }}: {{ c }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="relative mt-10">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex items-center justify-center">
					<div
						class="px-2.5 py-1 bg-body text-neutral-600 font-semibold"
					>
						Đánh giá về các lĩnh vực đã học
					</div>
				</div>
			</div>
			<div
				v-for="(s, index) in skills.length > 0
					? skills
					: assessment_results"
				:key="index"
				class="mt-10"
				:class="{
					block: skills.length > 0,
					'shadow-sm': skills.length > 0,
				}"
			>
				<div class="flex items-center justify-between mb-4">
					<div class="flex items-center">
						<div class="font-semibold text-neutral-700">
							{{ index + 1 }}. {{ s.skill?.name }}
						</div>
						<div class="flex items-center gap-2" v-if="s.age">
							<div>:</div>
							<div class="font-semibold text-green-500">
								{{ s.age }} {{ s.unit }}
							</div>
						</div>
					</div>
				</div>
				<div v-if="skills.length > 0">
					<div
						class="text-xs font-semibold uppercase mb-2 text-gray-400"
						v-if="s.age"
					>
						Tuổi phát triẻn
					</div>
					<div class="mb-4">
						<div class="text-gray-700">
							<span v-if="s.age">{{ s.age }} {{ s.unit }}</span>
						</div>
					</div>
					<div class="mb-4">
						<div
							class="text-xs font-semibold uppercase mb-2 text-gray-400"
							v-if="s.note"
						>
							Nhận xét chung
						</div>
						<div class="text-gray-700" v-html="s.note"></div>
					</div>
					<div class="mb-4">
						<div
							class="text-xs font-semibold uppercase mb-2 text-gray-400"
							v-if="s.recomended_for_parent"
						>
							Gợi ý cho phụ huynh
						</div>

						<div
							class="text-gray-700"
							v-html="s.recomended_for_parent"
						></div>
					</div>
					<div
						class="text-xs font-semibold uppercase mb-2 text-gray-400"
					>
						Các mục tiêu đã học
					</div>
				</div>
				<div
					class="shadow-sm sm:rounded-2xl overflow-hidden md-down:hidden"
				>
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="px-4 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16"
											scope="col"
										>
											STT
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
										>
											Mục Tiêu
										</th>
										<th
											class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											scope="col"
											style="width: 80px"
										>
											Kết quả
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(i, gIndex) in s.goals"
										:key="gIndex"
										:class="[
											gIndex % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50',
											i.show ? 'opacity-30' : '',
										]"
										class="text-neutral-700"
									>
										<td
											class="p-4 whitespace-nowrap text-neutral-700 text-center"
										>
											{{ gIndex + 1 }}
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div
												class="flex items-center gap-2"
											>
												<div
													class="whitespace-normal"
													v-html="
														i.name || i.goal_name
													"
												></div>
											</div>
											<div
												class="flex gap-2 flex-wrap"
												style="max-width: 360px"
											>
												<div
													class="mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap"
													style="font-size: 10px"
													v-if="i?.source"
												>
													{{ i?.source }}
												</div>
												<div
													class="mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap"
													style="font-size: 10px"
													v-else
												>
													{{
														$filters.sourceMap(
															i?.state,
															i.editable
														)
													}}
												</div>
												<template
													v-if="i?.assistance_levels"
												>
													<div
														v-for="ass in i?.assistance_levels"
														:key="ass"
														class="flex gap-2"
													>
														<div
															class="mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input"
															style="
																font-size: 10px;
															"
														>
															{{ ass }}
														</div>
													</div>
												</template>
												<div
													class="mt-1 py-0.5 px-2.5 rounded-full bg-yellow-tag text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap"
													style="font-size: 10px"
													v-if="i?.age"
												>
													{{ i?.age }}
												</div>
											</div>
											<div
												class="flex items-center gap-2 mt-2 text-neutral-400 text-xs font-semibold"
											>
												<div v-if="i?.has_media">
													<img
														alt=""
														src="@/assets/images/icons/has_media.png"
													/>
												</div>
												<div
													v-if="
														i.number_of_assessment >
														0
													"
												>
													ĐÃ HỌC
													{{ i.number_of_assessment }}
													NGÀY
												</div>
												<div
													v-if="i.display_start_date"
												>
													|
												</div>
												<div
													v-if="i.display_start_date"
												>
													{{ i.display_start_date }}
												</div>
												<div
													v-if="
														i.display_completed_at
													"
												>
													-
												</div>
												<div
													v-if="
														i.display_completed_at
													"
												>
													{{ i.display_completed_at }}
												</div>
												<div
													v-if="
														i?.display_completed_at
													"
												>
													<img
														alt=""
														src="@/assets/images/icons/has_taught.png"
													/>
												</div>
											</div>
											<div
												v-if="
													i.parent?.sub_goal_count > 0
												"
												class="goal-block flex gap-3 mt-2"
											>
												<img
													class="w-3 h-3 mt-1"
													src="@/assets/images/icons/goal-arrow.png"
													alt=""
												/>
												<div>
													<div
														class="text-neutral-700 whitespace-normal"
														v-html="i.parent?.name"
													></div>
													<div
														class="text-neutral-400 text-xs font-semibold"
													>
														{{
															i.parent
																?.sub_goal_count
														}}
														MỤC TIÊU
													</div>
												</div>
											</div>
										</td>
										<td
											class="px-6 py-4 whitespace-nowrap text-neutral-700"
										>
											<div>
												<div
													v-if="i?.complete_percent"
													:style="{
														background:
															$filters.tagResult(
																i?.complete_percent
															)?.background,
														color: $filters.tagResult(
															i?.complete_percent
														)?.color,
													}"
													class="py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input"
												>
													Đạt
													{{
														i?.complete_percent ||
														0
													}}%
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@import '../../../../../assets/styles/responsive';

.is-MT-show {
	width: 100vw;
	transform: translateX(0);
	transition: all 0.4s ease;

	@include media-breakpoint-up(lg) {
		width: 400px;
	}
}

.is-MT-hide {
	transform: translateX(450px);
	transition: all 0.4s ease;
}

.transition {
	transition: all 0.4s ease;
}

.content-report-is-show {
	@include media-breakpoint-up(lg) {
		padding-right: 448px;
	}
}

.content-report-is-hide {
	@include media-breakpoint-up(lg) {
		padding-right: 40px;
	}
}
.border-bot {
	border-bottom: 2px solid #faf5f1;
}
.percent {
	height: 24px;
	border-radius: 0 99px 99px 0;
	background: #f9a8d4;
}
.student-age {
	border: 3px dashed #86a8d0;
}
.r-age {
	background: #6390c3;
}
.d-age {
	background: #f9a8d4;
}
.student-age::before,
.student-age::after {
	content: '';
	position: absolute;
	left: -7.5px;
	width: 15px;
	height: 15px;
	background-color: #6390c3;
	border-radius: 50%;
}

.student-age::before {
	top: -10px;
}

.student-age::after {
	bottom: -10px;
}
.goal {
	border-radius: 8px;
	padding: 24px;
	background: #ffffff;
	border: none !important;
}
.opacity-30 {
	opacity: 0.3 !important;
}
.block {
	border-radius: 8px;
	padding: 24px;
	background: #ffffff;
	border: none !important;
}
</style>